import React from 'react';
import {Table} from "react-bootstrap";

const UESelectionTable = (props) => {
    return (
        <div style={{"height": "100%", borderTop: "4px solid white"}} className={"overflow-auto text-center"}>
            <Table size={"sm"} className={"m-0"}>
                <tbody>
                {props.item.length > 0 && props.item.map(m => {

                    let warning = (!m.Select && m.Preselection && (m.IsDecoche == null || m.IsDecoche)) ? "bg-warning text-white" : "";

                    return (
                        <tr key={m.UniteEnseignementID} className={warning}>
                            <td>{m.UniteEnseignementCode}</td>
                        </tr>
                    );
                })}
                </tbody>
            </Table>
        </div>
    );
}

const TotalECTS = (props) => {
    return (
        <div style={{"fontSize": "1.25rem"}} className={"bg-secondary py-2 px-4 text-center"}>
            Nombre de crédits: {props.ECTS}
        </div>
    );
}

function Aside(props) {
    return (
        <>
            <UESelectionTable {...props} />
            <TotalECTS {...props}/>
        </>
    );
}

export default Aside;